import request from '@/utils/request'

// 申请企业认证
export function addApply(data) {
  return request({
    url: '/company/company/apply',
    method: 'post',
    data: data
  })
}

// 查询企业认证状态
export function companyStatus() {
  return request({
    url: '/company/company/status',
    method: 'get'
  })
}


export function msgList(params) {
  return request({
    url: '/msg/msg/list',
    method: 'get',
		params
  })
}


// 消息详情
export function msgDetail(id) {
  return request({
    url: `/msg/msg/${id}`,
    method: 'get'
  })
}